<div style="background: #fbfbfb; border-top: 1px solid #dadada; margin-top: 10em;">
    <div class="container">
        <div class="footer-policies">
            <div class="policy-container">
                <div class="policy-icon">
                    <fa-icon [icon]="faShippingFast" size="6x"></fa-icon>
                </div>
                <div class="policy-info">
                    <span class="policy-info-title">GIAO HÀNG SIÊU TỐC</span>
                    <span class="policy-info-content">Nhận hàng trong vòng 2h</span>
                </div>
            </div>
            <div class="policy-container">
                <div class="policy-icon">
                    <fa-icon [icon]="faSync" size="6x"></fa-icon>
                </div>
                <div class="policy-info">
                    <span class="policy-info-title">ĐỔI TRẢ DỄ DÀNG</span>
                    <span class="policy-info-content">Dùng thử trong vòng 3 ngày</span>
                </div>
            </div>
            <div class="policy-container">
                <div class="policy-icon">
                    <fa-icon [icon]="faCreditCard" size="6x"></fa-icon>
                </div>
                <div class="policy-info">
                    <span class="policy-info-title">THANH TOÁN TIỆN LỢI</span>
                    <span class="policy-info-content">Trả tiền mặt, CK, trả góp 0%</span>
                </div>
            </div>
            <div class="policy-container">
                <div class="policy-icon">
                    <fa-icon [icon]="faComment" size="6x"></fa-icon>
                </div>
                <div class="policy-info">
                    <span class="policy-info-title">HỖ TRỢ NHIỆT TÌNH</span>
                    <span class="policy-info-content">Tư vấn, giải đáp mọi thắc mắc</span>
                </div>
            </div>
        </div>
    </div>
</div>
<div style="background: #fbfbfb; border-top: 1px dashed #dadada;">
    <div class="container">
        <div class="footer-links">
            <div class="links-group-container">
                <span class="links-group-title">GIỚI THIỆU HANOICOMPUTER</span>
                <p><a href="/information">Giới thiệu công ty</a></p>
                <p><a href="/contact">Thông tin liên hệ</a></p>
                <p><a href="#">Thông tin tuyển dụng</a></p>
                <p><a href="#">Tin tức</a></p>
                <span class="footer-social-icons">
                    <a href="#"><i class="icons fab fa-facebook-f"></i></a>
                    <a href="#"><i class="icons fab fa-youtube"></i></a>
                    <a href="#"><i class="fab fa-instagram"></i></a>
                </span>
            </div>
            <div class="links-group-container">
                <span class="links-group-title">HỖ TRỢ KHÁCH HÀNG</span>
                <p><a href="/guildline#payment">Hướng dẫn thanh toán</a></p>
                <p><a href="/guildline#installment">Hướng dẫn mua hàng trả
                        góp</a></p>
                <p><a href="/guildline#invoice">In hóa đơn
                        điện tử</a></p>
                <p><a href="/contact">Gửi yêu cầu hỗ trợ</a></p>
                <p><a href="/guildline#a&q">Thắc mắc, góp ý</a></p>
            </div>
            <div class="links-group-container">
                <span class="links-group-title">CHÍNH SÁCH CHUNG</span>
                <p><a href="/policies#delivery">Chính sách vận
                        chuyển & Thanh toán</a></p>
                <p><a href="/policies#warranty">Chính sách bảo hành</a>
                </p>
                <p><a href="/policies#warranty">Chính sách đổi, trả
                        lại hàng</a></p>
                <p><a href="/policies#payback">Chính sách hoàn tiền</a>
                </p>
                <p><a href="/policies#enterprise">Chính sách cho
                        doanh nghiệp</a></p>
                <p><a href="/policies#security">Bảo mật thông
                        tin khách hàng</a></p>
            </div>
            <div class="links-group-container">
                <span class="links-group-title">THÔNG TIN KHUYẾN MẠI</span>
                <p><a href="#">Thông tin khuyến mại</a></p>
                <p><a href="#">Sản phẩm khuyến mại</a></p>
                <p><a href="#">Sản phẩm bán chạy</a></p>
                <p><a href="#">Sản phẩm mới</a></p>
                <p>
                    <a href="#" target="_blank"><img src="/media/lib/dathongbao.png" data-src="/media/lib/dathongbao.png" alt="Đăng ký bộ công thương" class="lazy loaded" style="margin-top: -7px; margin-left: -7px; visibility: visible; zoom: 1; opacity: 1;" data-was-processed="true"></a>
                </p>
            </div>
        </div>
    </div>
</div>